import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Links.module.scss';
import Facebook from '../icons/Facebook';
import InstagramSmall from '../icons/InstagramSmall';
import Link from '../Link';
import Spotify from '../icons/Spotify';
import TikTok from '../icons/TikTok';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var footerLinks = [{
  key: 'column-a',
  links: [{
    ariaLabel: 'Login and view My Account.',
    href: '/account',
    title: 'My Account'
  }, {
    ariaLabel: 'View Gift Cards',
    href: '/products/digital-gift-certificate',
    title: 'Gift Cards'
  }, {
    ariaLabel: 'View all of our Fabrics',
    href: '/pages/fabrics',
    title: 'Fabrics'
  }, {
    ariaLabel: 'View all OV Shops in The United States.',
    href: '/pages/visit-us',
    title: 'Shops'
  }, {
    ariaLabel: 'View all OV Events in The United States.',
    href: 'https://events.outdoorvoices.com',
    title: 'Events'
  }, {
    ariaLabel: 'Learn about our Returns policies.',
    href: '/pages/returns',
    title: 'Returns'
  }, {
    ariaLabel: 'Need some Help? Find answers or contact us in the Help Center.',
    href: '/pages/help-center',
    title: 'Help Center'
  }]
}, {
  key: 'column-b',
  links: [{
    ariaLabel: 'Learn more about our university Student Discount.',
    href: '/pages/ov-university',
    title: 'Student Discount'
  }, {
    ariaLabel: 'Learn more About Us.',
    href: '/pages/about-us/',
    title: 'About Us'
  }, {
    ariaLabel: 'Explore our Careers.',
    href: '/pages/careers',
    title: 'Careers'
  }, {
    ariaLabel: 'Learn about our commitments to Sustainability.',
    href: '/pages/sustainability',
    title: 'Sustainability'
  }, {
    ariaLabel: 'Learn about our Accessibility.',
    href: '/pages/accessibility/',
    title: 'Accessibility'
  }, {
    ariaLabel: 'Learn about our Privacy policies.',
    href: '/privacy-policy',
    title: 'Privacy'
  }, {
    ariaLabel: 'Learn about our privacy Terms and conditions.',
    href: '/terms',
    title: 'Terms'
  }]
}];
var socialLinks = [{
  ariaLabel: 'Click to follow on Instagram',
  children: /*#__PURE__*/_jsx(InstagramSmall, {}),
  href: '//instagram.com/outdoorvoices/',
  name: 'Instagram'
}, {
  ariaLabel: 'Click to like on Facebook',
  children: /*#__PURE__*/_jsx(Facebook, {}),
  href: '//facebook.com/OutdoorVoices/',
  name: 'Facebook'
}, {
  ariaLabel: 'Click to follow on TikTok',
  children: /*#__PURE__*/_jsx(TikTok, {}),
  href: 'https://www.tiktok.com/@outdoorvoices',
  name: 'TikToke'
}, {
  ariaLabel: 'Click to follow on Spotify',
  children: /*#__PURE__*/_jsx(Spotify, {}),
  href: 'https://open.spotify.com/user/285uixxpw61bpmiuclmfoozpn',
  name: 'Spotify'
}];
export var Copyright = function Copyright(_ref) {
  var className = _ref.className,
      light = _ref.light;
  return /*#__PURE__*/_jsxs("span", {
    className: cc([css.copyright, className, _defineProperty({}, css.light, light)]),
    children: ["\xA9", "".concat(new Date().getFullYear(), " Outdoor Voices")]
  });
};
Copyright.defaultProps = {
  className: '',
  light: false
};
Copyright.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool
};
export var Social = function Social(_ref3) {
  var light = _ref3.light;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.social]),
    children: [/*#__PURE__*/_jsx("ul", {
      className: cc([css.iconLinks, css.list]),
      children: socialLinks.map(function (_ref4) {
        var ariaLabel = _ref4.ariaLabel,
            children = _ref4.children,
            href = _ref4.href,
            name = _ref4.name;
        return /*#__PURE__*/_jsx("li", {
          className: cc([css.linkItem, css.iconLink]),
          children: /*#__PURE__*/_jsx(Link, {
            ariaLabel: ariaLabel || "Visit Our ".concat(name, " Account"),
            href: href,
            light: light,
            targetBlank: true,
            children: children
          })
        }, href);
      })
    }), /*#__PURE__*/_jsx(Copyright, {
      light: light
    })]
  });
};
Social.defaultProps = {
  ariaLabel: false,
  light: false
};
Social.propTypes = {
  ariaLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  light: PropTypes.bool
};
export var GroupColumns = function GroupColumns(_ref5) {
  var light = _ref5.light,
      linkClass = _ref5.linkClass,
      links = _ref5.links,
      rootClass = _ref5.rootClass;
  return links.map(function (linkGroup) {
    return /*#__PURE__*/_jsx("ul", {
      className: cc([css.root, css.list, rootClass]),
      children: linkGroup.links.map(function (_ref6) {
        var ariaLabel = _ref6.ariaLabel,
            href = _ref6.href,
            targetBlank = _ref6.targetBlank,
            title = _ref6.title;
        return /*#__PURE__*/_jsx("li", {
          className: css.linkItem,
          children: /*#__PURE__*/_jsx(Link, {
            ariaLabel: ariaLabel,
            className: cc([css.link, linkClass]),
            href: href,
            light: light,
            targetBlank: targetBlank,
            children: title
          })
        }, title);
      })
    }, linkGroup.key);
  });
};
GroupColumns.defaultProps = {
  className: '',
  light: false
};
GroupColumns.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired
};